export const JobRoutes = {
  GET_ALL_JOBS: '/jobs',
  GET_NOTIFICATION_TYPES: '/jobs/notification-types',
  FINALIZING_HIRE_STEPS: '/jobs/finalizing-hire-steps',

  getJobRoute: (jobId?: number, route?: string) => `/job/${jobId || ':jobId'}${route || ''}`,

  JOB: '/',
  USERS: '/users',
  ACTIVE: '/active',
  MONTHLY_CREDIT_DOLLARS: '/monthly-credit-dollars',
  APPLICATIONS_LABELS: '/applications/labels',
  TEXT_MESSAGE_TEMPLATES: '/text-message-templates',
  ADD_TEXT_MESSAGE_TEMPLATE: '/text-message-templates/add',

  FACEBOOK_CAMPAIGN: '/facebook-campaign',

  NOTIFICATION_SUBSCRIPTIONS: '/notification-subscriptions',
  LABELS: '/labels',
  REFERRALS: '/referrals',
  DETAILS: '/details',
  CREATE_DEMO_APPLICANT: '/demo-applicant',
  APPLICANT: '/applicant',
};

export const TodoRoutes = {
  GET_ALL_TODOS: '/todos',
};
